// fork overlay: fork-owned route module (conversation pipeline kanban) — no OSS counterpart.
// Registered by the fork dashboard.routes.js aggregator overlay. Alias-form imports (D-07).
import { frontendURL } from 'dashboard/helper/URLHelper.js';
import PipelineView from 'dashboard/routes/dashboard/pipeline/PipelineView.vue';

// Deliberately narrower than the chat list's CONVERSATION_PERMISSIONS: the
// board renders raw /conversations/filter results (inbox-scoped only, like
// upstream folders), so roles limited to participating/unassigned
// conversations don't get a whole-pipeline surface.
const PIPELINE_PERMISSIONS = ['administrator', 'agent', 'conversation_manage'];

const pipelineRoutes = {
  routes: [
    {
      path: frontendURL('accounts/:accountId/pipeline'),
      name: 'pipeline_index',
      meta: {
        permissions: PIPELINE_PERMISSIONS,
      },
      component: PipelineView,
    },
  ],
};

export default pipelineRoutes;
